/**
 @ngdoc directive
 @name persistantTabDirective

 @description

 Designed to be used within _sideTabs.gsp

 On load, checks the current URL search params for a 'tab' property. 
 If it exists, it will search the DOM for an element with a matching id, 
 and simulate a click on that element.

 If the passed @Param persistantTab variable changes, this indicates a new
 tab has been selected by the user and the directive will update the global
 window variable 'tab'. The corresponding 'persistantTabController' listens
 for changes to this variable providing the developer access to the chosen tab
 anywhere in the system. Considering the need for two very separate parts of 
 the system to communciate, this was the safest way to faciliate the passing
 of data.

 @Param setDefaultTabOn override default behaviour of setting 1st on load.

 @usage

 <div ng-controller="persistantTabController as tabController">
     <a href="targetController/targetMethod?tab={{tabController.persistantTab}}"></a>
 </div>
 
 --------------------------------------------------------------------------------
 
 <a href="pageTargetForTabOne" id="tabOne" persistant-tab="formModel.targetTab"></a>
 <a href="pageTargetForTabTwo" id="tabTwo" persistant-tab="formModel.targetTab"></a>
 <a href="pageTargetForTabThree" id="tabThree" persistant-tab="formModel.targetTab"></a>

 */

(function () {
  "use strict";
  var persistantTabDirective = function () {
    return {
      restrict: "A",
      controllerAs: "ctrl",
      scope: {
        persistantTab: "=",
        setDefaultTabOn: "<?",
      },
      controller: function ($scope, $element) {
        $scope.setDefaultTabOn = angular.isDefined($scope.setDefaultTabOn)?$scope.setDefaultTabOn:true
        $scope.$watch("persistantTab", function (newValue, oldValue) {
            window.persistantTab = newValue
        });

        angular.element(document).ready(function () {
          const requestedTab = location.hash.replaceAll("#", '').replaceAll('!', '')
          if (requestedTab) {
            // find the corresponding tab and simulate a user click
            let element = angular.element(document.getElementById(requestedTab.toLowerCase()))
            if(Object.keys(element).length === 0){
              element = angular.element(document.getElementById(requestedTab))
            }
            element
              .triggerHandler("click");
            // some tabs are not assigned an id, so also update the pageModel for good measure
            $scope.persistantTab = requestedTab;
          } else {
            if($scope.setDefaultTabOn) {
              // if no tab has been requested, select the first tab by default. An id cannot be used because it changes across objects
              angular
                  .element($element[0].children[0].children[0])
                  .triggerHandler("click");
            }
          }
        });
      },
    };
  };
  angular.module("app").directive("persistantTab", persistantTabDirective);
})();
